import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {EvaluateDayEvent} from "@/modules/season/events/EvaluateDayEvent";
import {inject, injectable} from "inversify";
import {Team} from "@/modules/team/entity";
import {BankCategory} from "@/modules/finances/enums";
import {GateTypeEnum} from "@/modules/action-points/enums";
import GateManager from "@/modules/action-points/services/GateManager";

@injectable()
export class StaffMemberWageEventSubscriber implements EventSubscriber {
  constructor(
    @inject(GateManager) private gateManager: GateManager,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: EvaluateDayEvent, callback: this.onEvaluateDay},
    ];
  }

  async onEvaluateDay(event: EvaluateDayEvent): Promise<void> {
    if (event.season.currentDate.date() !== 15) {
      return;
    }

    console.time('wages');
    const team = await Team
      .createQueryBuilder('team')
      .leftJoinAndSelect('team.staffMembers', 'staffMember')
      .where('team.user = true')
      .getOneOrFail();

    const wages = collect(team.staffMembers).sum('wage') as number;

    if (wages > 0) {
      await this.gateManager.getGate(GateTypeEnum.BALANCE).currency.forceSubtract(
        wages,
        {
          category: BankCategory.WAGES,
          label: translator.t('staff_member_wages'),
        }
      );
    }

    console.timeEnd('wages');
  }
}